import { render, staticRenderFns } from "./perm.vue?vue&type=template&id=6e5eea26&"
import script from "./perm.vue?vue&type=script&lang=js&"
export * from "./perm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports